import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { OtherSettingsListComponent } from '@fi-app/other-settings/other-settings-list/other-settings-list.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { OtherSettingsSupportContactEditComponent } from '@fi-app/other-settings/other-settings-support-contact-edit/other-settings-support-contact-edit.component';
import { OtherSettingsService } from '@fi-app/other-settings/other-settings.service';
import { OtherSettingsSmtpEditComponent } from '@fi-app/other-settings/other-settings-smtp-edit/other-settings-smtp-edit.component';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

const FiOtherSettingsStatesResolve_pageTitle = [PageTitleService, FiOtherSettingsStatesResolve_pageTitle_resolveFunc];

const OtherSettingsState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings._name,
    url: '/OtherSettings',
    abstract: true,
    parent: FiStateNames.GlobalSettings,
    component: FiAbstractStateComponent,
};

const OtherSettingsListState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: OtherSettingsListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: FiOtherSettingsStatesResolve_pageTitle,
    },
};

const OtherSettingsSupportContactEditState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.SupportContact,
    url: '/SupportContact/Edit',
    views: {
        '@': {
            component: OtherSettingsSupportContactEditComponent,
        },
    },
    resolve: {
        supportContact: [OtherSettingsService, FiOtherSettingsStatesResolve_supportContact_resolveFunc],
        pageTitle: FiOtherSettingsStatesResolve_pageTitle,
    },
};

const OtherSettingsSmtpEditState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.Smtp,
    url: '/Smtp/Edit',
    views: {
        '@': {
            component: OtherSettingsSmtpEditComponent,
        },
    },
    resolve: {
        smtpServer: [OtherSettingsService, FiOtherSettingsStatesResolve_smtpServer_resolveFunc],
    },
};

export const FiOtherSettingsStates: StatesModule = {
    states: [
        OtherSettingsState,
        OtherSettingsListState,
        OtherSettingsSupportContactEditState,
        OtherSettingsSmtpEditState,
    ],
};

export function FiOtherSettingsStatesResolve_pageTitle_resolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByTextId('common.other_settings');
}

export function FiOtherSettingsStatesResolve_supportContact_resolveFunc(otherSettingsService: OtherSettingsService) {
    return otherSettingsService.getSupportContact();
}

export function FiOtherSettingsStatesResolve_smtpServer_resolveFunc(otherSettingsService: OtherSettingsService) {
    return otherSettingsService.getSmtpServer();
}

export function registerOtherSettingsStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules(
        [
            FiStateNames.OtherSettings.List,
            FiStateNames.OtherSettings.SupportContact,
            FiStateNames.OtherSettings.Smtp,
            FiStateNames.OtherSettings.TransferOwnership,
        ],
        {
            SettingType: [ApplicationSettingsType.CoreGlobal],
            AccessType: AccessRightType.Admin,
        },
    );
    stateAccessCheckService.registerStateRules([FiStateNames.OtherSettings.List], {
        SettingType: [ApplicationSettingsType.ConfidentialAgreement],
        AccessType: AccessRightType.Admin,
    });
    stateAccessCheckService.registerStateRules([FiStateNames.OtherSettings.List], {
        SettingType: [ApplicationSettingsType.Appearance],
        AccessType: AccessRightType.Admin,
    });
}
